import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserProgress } from "../model/progress";
import { getUsersProgress as getUsersProgramProgress } from "../api/progress";

interface ProgressState {
  currentUsersProgramProgress: UserProgress[] | null
}

const initialState: ProgressState = {
  currentUsersProgramProgress: [],
};

const progressSlice = createSlice({
  name: 'progress',
  initialState,
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsersProgramProgressAsync.fulfilled, (state: ProgressState, action: PayloadAction<UserProgress[]>) => {
        state.currentUsersProgramProgress = action.payload;
      })
      .addCase(getUsersProgramProgressAsync.rejected, (state: ProgressState, action) => {
        console.error(action.error.message);
      })
  }
});

export const getUsersProgramProgressAsync = createAsyncThunk('program/getUsersProgramProgressAsync', async ({ accessToken, programId }: { accessToken: string, programId: string}) => {
    const response = await getUsersProgramProgress(accessToken, programId);
    return response;
  }
);

export const { } = progressSlice.actions;
export default progressSlice.reducer;